export const Force = () => {
    return (
        <div className="container">
            <h2>強制発現</h2>
            <p>現在非推奨です</p>
        </div>
    )
}